window.updateTotalPrice = () => {
  const standPrice = document.querySelector('#stand-price .price-euro') ? parseFloat(document.querySelector('#stand-price .price-euro').innerHTML.replace(',', '.')) : 0
  const reservePrice = parseFloat(document.querySelector('#reserve-price .price-euro')?.innerHTML.replace(',', '.')) || 0
  const elecPrice = parseFloat(document.querySelector('#elec-price .price-euro')?.innerHTML.replace(',', '.') || 0)
  const eauPrice = parseFloat(document.querySelector('#eau-price .price-euro')?.innerHTML.replace(',', '.') || 0)
  const internetPrice = parseFloat(document.querySelector('#internet-price .price-euro')?.innerHTML.replace(',', '.') || 0)
  const wifiPrice = parseFloat(document.querySelector('#wifi-price .price-euro')?.innerHTML.replace(',', '.') || 0)
  const parkingPrice = parseFloat(document.querySelector('#parking-price .price-euro')?.innerHTML.replace(',', '.') || 0)
  const elinguesPrice = parseFloat(document.querySelector('#elingues-price .price-euro')?.innerHTML.replace(',', '.') || 0)

  const totalPrice = standPrice + reservePrice + elecPrice + eauPrice + internetPrice + wifiPrice + elinguesPrice + parkingPrice
  if (document.querySelector('#total-price .price-euro')) {
    document.querySelector('#total-price .price-euro').innerHTML = totalPrice.toFixed(2).toString().replace('.', ',')
  }
  const totalPriceStripe = document.getElementById('commands_total_price')
  if (totalPriceStripe) {
    totalPriceStripe.value = totalPrice.toFixed(2)
  }
}

const CATEGORY_KEYS = ['elec', 'eau', 'internet', 'wifi', 'parking', 'elingues']

const initCategoryPriceListener = (categoryKey) => {
  const section = document.querySelector(`[data-category-orders="${categoryKey}"]`)
  if (!section) return

  const checkboxes = section.querySelectorAll('.category-amenity-checkbox')
  const qtyInputs = section.querySelectorAll('[data-amenity-quantity]')
  const priceForm = document.querySelector(`form.${categoryKey}`)
  const priceField = document.getElementById(`${categoryKey}_price`)
  if (!priceForm || !priceField) return

  const submitUpdate = () => {
    let checked = ''
    checkboxes.forEach((cb) => {
      if (cb.checked) {
        checked += checked === '' ? cb.value : ',' + cb.value
      }
    })
    priceField.value = checked

    qtyInputs.forEach((input) => {
      const amenityId = input.dataset.amenityId
      const hidden = document.getElementById(`${categoryKey}_quantity_${amenityId}`)
      if (hidden) hidden.value = input.value
    })

    Rails.fire(priceForm, 'submit')
  }

  ;[...checkboxes, ...qtyInputs].forEach((element) => {
    element.addEventListener('change', submitUpdate)
  })
}

const lockCheckbox = (checkbox, locked) => {
  if (!checkbox) return
  checkbox.style.pointerEvents = locked ? 'none' : 'auto'
  checkbox.style.cursor = locked ? 'not-allowed' : 'pointer'
}

const initAutoSelectRules = () => {
  document.querySelectorAll('[data-auto-selects-id]').forEach((row) => {
    const triggerCheckbox = row.querySelector('.category-amenity-checkbox')
    const companionRow = document.querySelector(`[data-amenity-id="${row.dataset.autoSelectsId}"]`)
    const companionCheckbox = companionRow?.querySelector('.category-amenity-checkbox')
    if (!triggerCheckbox || !companionCheckbox) return

    const syncCompanion = () => {
      if (triggerCheckbox.checked) {
        companionCheckbox.checked = true
        lockCheckbox(companionCheckbox, true)
        const label = document.querySelector(`label[for="${companionCheckbox.id}"]`)
        if (label) label.style.color = 'black'
        companionCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
      } else {
        lockCheckbox(companionCheckbox, false)
      }
    }

    if (triggerCheckbox.checked) lockCheckbox(companionCheckbox, true)
    triggerCheckbox.addEventListener('change', syncCompanion)
  })
}

const initUpdateCommandsPrices = () => {
  window.updateReservePrice = () => {
    const reserveInput = document.getElementById('commands_reserve') || document.getElementById('estimate_reserve')
    if (reserveInput) {
      reserveInput.addEventListener('change', () => {
        document.getElementById('reserve_price').value = `${reserveInput.value}`
        Rails.fire(document.querySelector('form.reserve'), 'submit')
      })
    }
  }

  window.updateStandPrice = () => {
    const standInput = document.getElementById('estimate_stand')
    if (!standInput) return
    standInput.addEventListener('change', () => {
      document.querySelector('#stand-price .price-euro').innerHTML = `${(parseInt(standInput.value) * 2897.05).toFixed(2).replace('.', ',')}`
    })
  }

  window.initCategoryPriceListeners = () => {
    window.updateReservePrice()
    CATEGORY_KEYS.forEach((key) => initCategoryPriceListener(key))
    initAutoSelectRules()
    window.updateTotalPrice()
  }

  if (document.querySelector('.new_orders__container') || document.querySelector('#update-commands-form') || document.querySelector('.inscription-exposant-content')) {
    window.initCategoryPriceListeners()
  }
}

export { initUpdateCommandsPrices }
